import { useLiveStreamAppContext } from "../ContextStore/Store";
import axios from "axios";

const FetchRoomDetail = () => {
  const {
    setIsNetworkError,
    __appAppEventtype,
    __appConfirmUniqueID,
    __merchantId,
    __setUserId,
    __userId,
    setIsInstructorMode,
    role,
    apiUrlPost,
    headers,
    setLoaderAnimation,
    setErrorMessage,
    setAppEndTimeUTC,
    setAppStartTimeUTC,
    setEventType,
    setClassesName,
    setTotalLicenseRequired,
    setFirstName,
    setLastName,
    setStaticGId,
    setServiceProviderId,
    setScreenName,
    setPhotoHostUrl,
    setPhotoUrl,
    setUserExists,
    setUserName,
    setUserNameHost,
    setAvtarInitials,
    setAttendeeList,
    setAcsLiveStreamEndpoint,
    setBusinessURL,
    setMessage,
    appInsightTrack,
    setVideoNamePlayback,
    setCurrentDateTimeUTC,
  } = useLiveStreamAppContext();

  function capitalizeEachWord(str) {
    return str
      .split(" ")
      .map(word =>
        word.length > 1
          ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          : word.toUpperCase()
      )
      .join(" ");
  }


  async function roomdetail() {
    let attempt = 0;
    const fetchRoomDetail = async () => {
      attempt++;
      try {
        setIsNetworkError(false);
        if (__appAppEventtype !== null) {
          setIsInstructorMode(false);
        }
        const roomDetailResponse = await axios.post(
          `${apiUrlPost}roomdetail`,
          {
            AppConfirmUniqueId: __appConfirmUniqueID,
            userId: __userId,
            attendeeType:
              role === "Presenter" ? 1 : role === "Attendee" ? 2 : 0,
            Eventtype:
              __appAppEventtype === null ? 1 : parseInt(__appAppEventtype),
          },
          { headers }
        );
        let data = roomDetailResponse.data.data;
        if (data) {

          let currentPath = window.location.pathname;
          const path = currentPath.includes("/recording-playback") || currentPath.includes("/feedbackhost")
            || currentPath.includes("/feedback") || currentPath.includes("/review");
          if (!data.serviceName && !path) {
            setLoaderAnimation(false);
            if (data.message.toLowerCase().includes("failed to fetch")) {
              setErrorMessage("You can not host Live Stream Appointment of another employee.");
            }
            else {
              setErrorMessage(data.message);
            }
            return;
          }
          else if (!path && !data.message.toString().includes("Success")) {
            setLoaderAnimation(false);
            if (data.message.toLowerCase().includes("failed to fetch")) {
              setErrorMessage("You can not host Live Stream Appointment of another employee.");
            }
            else {
              setErrorMessage(data.message);
            }
            return;
          }
          let matchedAttendee;
          setAppEndTimeUTC(data.appEndTimeUTC);
          setCurrentDateTimeUTC(data.currentDateTimeUTC);
          setAppStartTimeUTC(data.appStartTimeUTC);
          setEventType(data.eventType);
          setClassesName(data.serviceName);
          setVideoNamePlayback(data.serviceName);
          setTotalLicenseRequired(data.totalLicenseRequired);
          setFirstName(data.firstName);
          setLastName(data.lastName);
          setStaticGId(data.staticGId);
          setServiceProviderId(data.userId);
          data.screenName !== "" ? setScreenName(data.screenName) : setScreenName(data.firstName + " " + data.lastName);

          if (role === "Presenter") {
            setPhotoUrl(data.photo);
            setPhotoHostUrl(data.photo);
            setUserName(
              data.screenName === ""
                ? data.firstName + " " + data.lastName
                : data.screenName
            );
            setUserNameHost(
              capitalizeEachWord(
                data.screenName === ""
                  ? data.firstName + " " + data.lastName
                  : data.screenName
              )
            );
            __setUserId(data.userId);
            const params = new URLSearchParams(window.location.search);
            params.set("uid", data.userId);
            window.history.replaceState(
              {},
              "",
              `${window.location.pathname}?${decodeURIComponent(
                params.toString()
              )}`
            );
          } else {
            setPhotoHostUrl(data.photo);
            matchedAttendee = data?.attendees?.find(
              (attendee) => attendee.userId === __userId
            );
            matchedAttendee && setPhotoUrl(matchedAttendee.photo);
            matchedAttendee &&
              setUserName(
                matchedAttendee.screenName === ""
                  ? matchedAttendee.firstName + " " + matchedAttendee.lastName
                  : matchedAttendee.screenName
              );
            setUserNameHost(
              capitalizeEachWord(
                data.screenName === ""
                  ? data.firstName + " " + data.lastName
                  : data.screenName
              )
            );
            if (data.screenName === "") {
              setAvtarInitials(matchedAttendee.screenName === ""
                ? matchedAttendee.firstName + " " + matchedAttendee.lastName
                : matchedAttendee.screenName);
            } else {
              setAvtarInitials(data.screenName);
            }
            if (matchedAttendee) {
              setUserExists(true);
            }
          }
          const attendees = data.attendees;
          const updatedCustomers = attendees.map((customer) => ({
            ...customer,
            isAvatar: customer.photo !== "",
          }));
          setAttendeeList(updatedCustomers);
          setAcsLiveStreamEndpoint(data.acsLiveStreamEndpoint);
          setBusinessURL(data.businessURL);
          setMessage(data.message);
        }
      } catch (error) {
        setLoaderAnimation(false);
        setErrorMessage(`Getting Error from roomdetail API, ${error.message}`);
        console.error("Error fetching room detail response", error);
        appInsightTrack(__merchantId, __userId, "API Error roomdetail", "", error);

        // Retry up to 3 times if there is an error
        if (attempt < 3) {
          await fetchRoomDetail();
          return; // Exit the current function execution to prevent duplicate loading state toggles
        }
      }
    };
    await fetchRoomDetail();
  }
  return { roomdetail }
}

export default FetchRoomDetail;